import { Lock } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import { useTheme } from '@/contexts/ThemeContext';
import { DesignPicker } from './DesignPicker';
import { ColorThemeGrid } from './ColorThemeGrid';

const LockedNote = () => (
  <p className="text-xs text-muted-foreground flex items-center gap-1" data-testid="appearance-locked-note"><Lock className="w-3 h-3" />Fijado por tu administrador para tu rol</p>
);

const ToggleRow = ({ label, hint, checked, onChange, disabled, testid }) => (
  <div className="flex items-center justify-between gap-4">
    <div>
      <Label>{label}</Label>
      {hint && <p className="text-xs text-muted-foreground">{hint}</p>}
    </div>
    <Switch checked={checked} onCheckedChange={onChange} disabled={disabled} data-testid={testid} />
  </div>
);

// Apariencia propia del usuario: se guarda en el servidor y lo sigue en cualquier dispositivo
export const MyAppearanceCard = () => {
  const { userDesign, setDesign, theme, setTheme, themes, modernDark, setModernDark, highContrast, setHighContrast, locked, businessDesigns } = useTheme();
  const modern = userDesign === 'modern';
  return (
    <Card data-testid="my-appearance-card">
      <CardHeader>
        <CardTitle>Mi apariencia</CardTitle>
        <CardDescription>Solo para vos. Se guarda en tu cuenta y la ves igual en cualquier dispositivo.</CardDescription>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="space-y-2">
          <Label>Tema visual</Label>
          <DesignPicker value={userDesign} onChange={setDesign} disabled={locked.theme} testid="my-design" />
          {locked.theme ? <LockedNote /> : businessDesigns && (
            <p className="text-xs text-muted-foreground">El negocio usa {businessDesigns.panel_theme === 'modern' ? 'Moderno' : 'Clásico'} por defecto.</p>
          )}
        </div>
        <div className="space-y-2">
          <Label>{modern ? 'Color de acento' : 'Tema de color'}</Label>
          <ColorThemeGrid themes={themes} value={theme} onChange={setTheme} modern={modern} />
        </div>
        <div className="space-y-4">
          {modern && <ToggleRow label="Modo oscuro" checked={modernDark} onChange={setModernDark} testid="my-dark-toggle" />}
          <ToggleRow label="Alto contraste" hint="Textos y bordes más marcados, para leer mejor con sol o poca vista"
            checked={highContrast} onChange={setHighContrast} disabled={locked.high_contrast} testid="my-hc-toggle" />
          {locked.high_contrast && <LockedNote />}
        </div>
      </CardContent>
    </Card>
  );
};
